import { Button } from '@atd/rui-base.mui.button'
import { FormControl } from '@atd/rui-base.mui.form-control'
import { FormControlLabel } from '@atd/rui-base.mui.form-control-label'
import { IconButton } from '@atd/rui-base.mui.icon-button'
import { InputLabel } from '@atd/rui-base.mui.input-label'
import { MenuItem } from '@atd/rui-base.mui.menu-item'
import { Radio } from '@atd/rui-base.mui.radio'
import { RadioGroup } from '@atd/rui-base.mui.radio-group'
import { Select } from '@atd/rui-base.mui.select'
import ValidatedTextField from '../commonComponents/validatedTextField'
import { RavenThemeScope } from '../ravenV5Theme'

import AddIcon from '@mui/icons-material/Add'
import InfoIcon from '@mui/icons-material/Info'
import OneProductRx from './oneProductRx'
import React from 'react'
import { checkProductLimits } from '../lib/ddiUnits'
import { connect } from 'react-redux'
import { getMenuItemsForProductDDI } from '../commonComponents/unitMenuItems'
import { selectMixes } from './productReducer'

function mapStateToProps(state, ownProps) {
    return {
        mixes: selectMixes(state),
        currentProducts: state.product.currentProducts,
    }
}

function mapDispatchToProps(dispatch) {
    return {}
}

class OneProduct extends React.Component {
    static defaultProps = {
        data: {},
    }
    componentDidMount() {
        this.autoSelectMix(this.props.mixes, this.props.data.mixId)
    }

    componentDidUpdate(prevProps) {
        if (this.props.mixes !== prevProps.mixes || this.props.data.mixId !== prevProps.data.mixId) {
            this.autoSelectMix(this.props.mixes, this.props.data.mixId)
        }
    }

    state = {
        warningDialogOpen: false,
    }

    autoSelectMix(mixes, mixId) {
        if (mixId > 0) {
            return
        }

        const water = mixes.find(mix => { return mix.name === 'Water' })
        if (water !== undefined) {
            this.props.selectMix(this.props.data.id, water.id)
        }
        else if (mixes.length > 0) {
            this.props.selectMix(this.props.data.id, mixes[0].id)
        }
    }
    handleNewMixRequest = () => {
        this.props.newMixRequest(this.props.data.id)
    }
    handleInfo = () => {
        this.props.mixReviewRequest(this.props.data.id)
    }
    handleMixSelect = (event, index, value) => {
        if (value >= 0) {
            this.props.selectMix(this.props.data.id, value)
        }
        else {
            this.handleNewMixRequest()
        }
    }
    handleTextChange = (event) => {
        this.props.setProductProperty(this.props.data.id, event.target.name, event.target.value)
    }

    handleUnit = (event, index, value) => {
        this.props.setProductProperty(this.props.data.id, 'userDisplayUnit', value)
    }

    handleModeChange = (event, value) => {
        this.props.selectMode(this.props.data.id, value)
    }
    handleDelete = event => {
        this.props.deleteProduct(this.props.data.id)
    }
    createMixDropDownList = () => {
        const addButton = (
            <MenuItem value={-1} key={'new'} label={'Select a Mix'} name="newMix">
                <RavenThemeScope>
                    <Button variant="contained"
                        color="primary"
                        fullWidth
                        onClick={this.handleNewMixRequest}
                        name="addMixButton"><AddIcon htmlColor="white" /></Button>
                </RavenThemeScope>
            </MenuItem>
        )

        const uniqueMixes = [...new Map(this.props.mixes.map((mix) => [mix.id, mix])).values()]

        return [
            addButton,
            ...uniqueMixes.map((data) => {
                return <MenuItem key={data.id} value={data.id} name={data.id}>{data.name}</MenuItem>
            }),
        ]
    }

    renderDelete = () => {
        if (this.props.disabled) return

        return (
            <IconButton
                className="productDelete"
                name="deleteProduct"
                sx={{ marginLeft: 'auto' }}
                onClick={this.handleDelete}>
                <img className="standardIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_DeleteBlack.svg`}/>
            </IconButton>
        )
    }
    getRateLabel = () => {
        if (this.props.data.mode === 'targetRate') { return 'Target Rate' }
        else if (this.props.data.mode === 'rxMap') { return 'Default Rate' }
    }
    getRxSection = (rateUnits) => {
        if (this.props.data.mode !== 'rxMap') { return }

        return (
            <OneProductRx
                data={this.props.data}
                rateUnits={rateUnits}
                setProductProperty={this.props.setProductProperty}
                disabled={this.props.disabled}
            />)
    }
    renderRateInfo = () => {
        const rateUnits = getMenuItemsForProductDDI(this.props.data.ddiId)
        const errorText = checkProductLimits(this.props.data.displayRate, this.props.data.userDisplayUnit, this.props.data.mode == 'rxMap')
        const rateLabel = this.getRateLabel()
        const rxSection = this.getRxSection(rateUnits)

        return (
            <div className="rates" name="rateInfo">
                {rxSection}
                <ValidatedTextField
                    className="textField"
                    label={rateLabel}
                    onChange={this.handleTextChange}
                    defaultValue={this.props.data.displayRate || ''}
                    disabled={this.props.disabled}
                    errorText={errorText}
                    name="displayRate"
                />
                <FormControl variant="standard" className="selectField" disabled={this.props.disabled} error={!this.props.data.userDisplayUnit}>
                    <Select
                        value={this.props.data.userDisplayUnit}
                        onChange={(event) => this.handleUnit(event, null, event.target.value)}
                        name="rateUnits"
                    >
                        {rateUnits}
                    </Select>
                </FormControl>
            </div>
        )

    }

    render() {
        const availMixes = this.createMixDropDownList()
        const rateEntry = this.renderRateInfo()
        const deleteButton = this.renderDelete()

        return (
            <div style={{borderBottom: 'solid', paddingBottom: '16px'}} name={`Product-${this.props.data.id}`}>
                <div style={{display: 'flex', alignItems: 'center', marginTop: '10px'}}>
                    <FormControl
                        variant="standard"
                        className="mixSelectField"
                        disabled={this.props.disabled}
                        error={this.props.data.mixId <= 0}
                    >
                        <InputLabel>Mix</InputLabel>
                        <Select
                            value={this.props.mixes.some((mix) => mix.id === this.props.data.mixId) ? this.props.data.mixId : ''}
                            onChange={(event) => this.handleMixSelect(event, null, event.target.value)}
                            label="Mix"
                            name="mixSelect"
                        >
                            {availMixes}
                        </Select>
                    </FormControl>
                    <IconButton
                        className="mixInfoButton"
                        name="mixInfoButton"
                        onClick={this.handleInfo}>
                        <InfoIcon/>
                    </IconButton>
                    {deleteButton}
                </div>
                <div className="rowFlex">
                    <div className="radioButtonGroup" name="rateRadioButtons">
                        <label>Rate:</label>
                        <RadioGroup
                            name="rateMode"
                            value={this.props.data.mode}
                            onChange={this.handleModeChange}
                        >
                            <FormControlLabel
                                value="targetRate"
                                label=""
                                control={
                                    <Radio
                                        className="radioButton"
                                        disabled={this.props.disabled}
                                        checkedIcon={<img className="clickedIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Target.svg`}/>}
                                        icon={<img className="clickableIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Target.svg`}/>}
                                        name="targetRateButton"
                                    />
                                }
                            />
                            <FormControlLabel
                                value="rxMap"
                                label=""
                                control={
                                    <Radio
                                        className="radioButton"
                                        disabled={this.props.disabled}
                                        checkedIcon={<img className="clickedIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Rx.svg`}/>}
                                        icon={<img className="clickableIcon" src={`${process.env.PUBLIC_URL}/images/jobIcons/Job_Rx.svg`}/>}
                                        name="rxMapButton"
                                    />
                                }
                            />
                        </RadioGroup>
                    </div>
                    {rateEntry}
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OneProduct)
